import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { AuthenticationService } from '../../../services/authentication.service'
import * as firebase from 'firebase/auth'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { ClientService } from '../../../services/client.service'
import { GoogleTagManagerService } from 'angular-google-tag-manager'
import { GlobalService } from '../../../services/global.service'
import User = firebase.User

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Input() showFindParking = true
    @Input() sideMenuButton = false
    @Output() onSideMenu = new EventEmitter<void>()

    user: User | null
    returnUrl: string | null
    activeMerchant: any
    logoUrl: string = 'assets/images/branding/logo.svg'
    headerClass: string = 'navbar-dark bg-dark'
    headerPaddingClass = ''
    GlobalService = GlobalService

    constructor(
        public globalService: GlobalService,
        public authService: AuthenticationService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public clientService: ClientService,
        private gtmService: GoogleTagManagerService
    ) {
        this.activatedRoute.queryParams.forEach((queryParams) => {
            if (queryParams['returnUrl']) {
                this.returnUrl = queryParams['returnUrl']
            } else {
                this.returnUrl = null
            }
        })

        // Track each page view event
        this.router.events.forEach((item) => {
            if (item instanceof NavigationEnd) {
                const gtmTag = {
                    event: 'page',
                    pageName: item.url,
                }
                this.gtmService.pushTag(gtmTag)
            }
        })

        // Standard ParkUpp header styling
        // Note: Enterprise domains use dedicated header components (e.g., app-redefine-header)
        // so this header is only shown on standard ParkUpp pages
        document.documentElement.style.setProperty('--whitelabel-header-color', '#001533')
    }

    ngOnInit(): void {
        this.authService.auth.onAuthStateChanged((user) => {
            this.user = user
        })
    }

    ngOnDestroy(): void {}

    signOut() {
        this.authService
            .signOut()
            .then(() => {
                this.router.navigate([''])
            })
            .catch((e) => {
                console.log(e.message)
            })
        return false
    }

    onMerchantPortal() {
        this.router.navigate([`merchant/portfolios`])
        return false
    }

    // onClientProfile() {
    //     if (this.clientService.activeClient && this.clientService.activeClient.firstName) {
    //         this.router.navigate([`client/${this.authService.uid}`])
    //     } else {
    //         this.router.navigate([`client/create`])
    //     }
    //     return false
    // }

    onSignIn() {
        if (this.returnUrl) {
            this.router.navigate(['sign-in'], { queryParams: { returnUrl: this.returnUrl } })
        } else {
            this.router.navigate(['sign-in'])
        }
        return false
    }

    onSignUp() {
        if (this.returnUrl) {
            this.router.navigate(['sign-up'], { queryParams: { returnUrl: this.returnUrl } })
        } else {
            this.router.navigate(['sign-up'])
        }
        return false
    }
}
